const checkTelephone = (telephone: string) => {
    return new RegExp(/^\+[1-9]\d{1,14}$/).test(telephone);
};

export default checkTelephone
